export default "__VITE_ASSET__YZQ6MHaS__"